import { useContext } from 'react'
import './styles.css'
import useResultSearch from '../../../viewModels/transport/ResultSearch_Model'
import TransportContext from '../../../../Context/transport/TransportProvider'
import { ArrowDown2, HambergerMenu, People, Timer } from 'iconsax-react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import useTransport from '../../../viewModels/transport/TransportC'
import banner from "../../../assets/pictures/header-traslado.png"
import lettersTransport from '../../../assets/images/lettersTransport.png'
import CarouselSevices, { servicesTravel } from '../../share/components/CarouselServices/CarouselSevices';
import Loading from '../../../views/share/components/loading';
import Find from '../../share/components/Find/Find';
import { Link } from 'react-router-dom';


const ResultSearch = () => {
  const { resultados } = useContext(TransportContext)
  const {
    menuHambur,
    buscadorMenu,
    filtersMenu,
    passengerFilter,
    setPassengerFilter,
    filtrado,
    activeFilterP,
    setActiveFilterP,
    resetFilter,
    setActiveFilterPrice,
    activeFilterPrice,
    setFirstRange,
    setSecondRange,
    errorFilter
  } = useResultSearch()

  const {

    adult,

    baby,

    setTypeT,
    ciudadDropdown,
    setCiudadDropdown,
    aeropuertoDropdown,
    setAeropuertoDropdown,

    passengersCal,

    findCity,
    cityList,
    citySelected,
    setcitySelected,
    findOrigin,
    originList,
    originSelected,

    setOriginSelected,
    findDestiny,
    destinyList,

    destinySelected,
    setDestinySelected,
    destinyDropdown,
    setDestinyDropdown,
    findServices,
    selectedDate,
    handleDateChange,
    loader,
    formValidate
  } = useTransport()



  return (
    <div>

      <Find />
      <CarouselSevices
        current={servicesTravel[3].title}
      />
      <section className='route-page'>
        <h3>
          Travel {'>'} <Link to={'/transport'}>Traslados</Link>  {'>'} <span>Buscador</span>
        </h3>
        <div className='filter-order'>
          <p>Ordenar por:</p>
          <div>
            <span>Mas Elegido</span>
            <ArrowDown2 size="20" color="#004274" />
          </div>
        </div>
      </section>
      <main className='contenedor-principal-resultados'>
        <div className='hamburger-menu-filters'>
          <span onClick={() => { menuHambur(false) }}><HambergerMenu size="20" color="#004274" /> Buscar</span>
          <span onClick={() => { menuHambur(true) }}><HambergerMenu size="20" color="#004274" /> Filtrar</span>
        </div>
        <aside className={'filters-container buscador-mobile'}>
          <form className={buscadorMenu === false ? 'display-none' : ''} action="" onSubmit={e => findServices(e)}>
            <div className="campo-t">
              <label htmlFor="">Tipo de Traslado:</label>
              <select className='input-ca' name="" id="" onChange={(e) => (setTypeT(e.target.value))}>
                <option value="">Selecciona Tipo de Traslado</option>
                <option value="ONLY_TO_AIRPORT">Ida Aeropuerto</option>
                <option value="ONLY_FROM_AIRPORT">Ida Hotel</option>
                <option value="ROUND_TRIP">Ida y Vuelta</option>
              </select>
            </div>
            <div className="campo-t">
              <label htmlFor="">Ciudad:</label>
              <div className="input-ca" onClick={() => setCiudadDropdown(!ciudadDropdown)}>

                <p>{citySelected !== '' ? citySelected.name : 'Selecciona Ciudad'}</p> <span><ArrowDown2 size="20" color="rgb(78, 78, 78)" /></span>

              </div>

              {
                ciudadDropdown === true &&
                <div className='dropdown-ciudad shadow' >
                  <div style={{ background: "white", borderRadius: "15px", width: "100%" }}>
                    <input className='input-dropdown' onChange={(e) => findCity(e.target.value)} type="text" placeholder='Ciudad' />

                  </div>
                  <ul className='city-result'>
                    {cityList &&
                      cityList.map((item) => {
                        return (
                          <li onClick={() => {
                            setcitySelected(item)
                            setCiudadDropdown(!ciudadDropdown)
                          }} key={item.id}>
                            {item.name}
                          </li>
                        )
                      })}
                  </ul>
                </div>
              }


            </div>
            <div className="campo-t">
              <label htmlFor="">Origen:</label>
              <div className="input-ca" onClick={() => {
                setAeropuertoDropdown(!aeropuertoDropdown)
                findOrigin()
              }}>
                <p>{originSelected !== '' ? originSelected.name : 'Selecciona Aeropuerto'}</p> <span><ArrowDown2 size="20" color="rgb(78, 78, 78)" /></span>
              </div>
              {
                aeropuertoDropdown === true &&
                <div className='dropdown-ciudad shadow' >
                  <div style={{ background: "white", borderRadius: "15px", width: "100%" }}>
                    <input className='input-dropdown' type="text" placeholder='Aeropuerto' />
                  </div>
                  <ul className='city-result'>
                    {originList &&
                      originList.map((item) => {
                        return (
                          <li onClick={() => {
                            setOriginSelected(item)
                            setAeropuertoDropdown(!aeropuertoDropdown)
                          }} key={item.id}>
                            {item.name}
                          </li>
                        )
                      })}
                  </ul>
                </div>
              }
            </div>
            <div className="campo-t">
              <label htmlFor="">Destino:</label>
              <div className="input-ca" onClick={() => {
                setDestinyDropdown(!destinyDropdown)
                findDestiny()
              }}>
                <p>{destinySelected !== '' ? destinySelected.name : 'Selecciona Destino'}</p> <span><ArrowDown2 size="20" color="rgb(78, 78, 78)" /></span>
              </div>
              {
                destinyDropdown === true &&
                <div className='dropdown-ciudad shadow' >
                  <div style={{ background: "white", borderRadius: "15px", width: "100%" }}>
                    <input className='input-dropdown' type="text" placeholder='Aeropuerto' />
                  </div>
                  <ul className='city-result'>
                    {destinyList &&
                      destinyList.map((item) => {
                        return (
                          <li onClick={() => {
                            setDestinySelected(item)
                            setDestinyDropdown(!destinyDropdown)
                          }} key={item.id}>
                            {item.name}
                          </li>
                        )
                      })}
                  </ul>
                </div>
              }
            </div>
            <div className='campo-t'>
              <label htmlFor="">Selecciona Fecha y Hora:</label>
              <DatePicker
                selected={selectedDate}
                onChange={handleDateChange}
                showTimeSelect
                dateFormat="yyyy-MM-dd-HH-mm"
                className='input-ca'
              />
            </div>

            <div className="campo-three">
              <div>
                <label htmlFor="">Adultos <br /> <span>+18</span></label>
                <div className='btn-passengers'>
                  <button onClick={(e) => passengersCal(e, "ad", 1)}>
                    +
                  </button>
                  <span>{adult}</span>
                  <button onClick={(e) => passengersCal(e, "ad", -1)}>
                    -
                  </button>
                </div>
              </div>

              <div>
                <label htmlFor="">Bebes <br></br> <span>-1 Año</span></label>
                <div className='btn-passengers'>
                  <button onClick={(e) => passengersCal(e, "bb", 1)}>
                    +
                  </button>
                  <span>{baby}</span>
                  <button onClick={(e) => passengersCal(e, "bb", -1)}>
                    -
                  </button>
                </div>
              </div>
            </div>
            {
              formValidate === '' ?
                ''
                :
                <div className='error-form'>
                  <p>{formValidate}</p>
                </div>
            }
            <div className='contain-btn-t'>
              <button onClick={() => resetFilter()} >Buscar Traslado</button>
            </div>
          </form>
          <div className={filtersMenu === true ? 'filters-box' : 'display-none filters-box'}>
            <section className="container-filter-price">
              <h3>
                Precios
              </h3>
              <div className='input-filtrado-price'>
                <div>
                  <label htmlFor="">Desde</label>
                  <input onChange={(e) => { setFirstRange(e.target.value) }} type="number" />
                </div>
                <div>
                  <label htmlFor="">Hasta</label>
                  <input onChange={(e) => { setSecondRange(e.target.value) }} type="number" />
                </div>
                {
                  errorFilter === '' ?
                    ''

                    :
                    <div className='error-form top-m'>
                      <p>{errorFilter}</p>
                    </div>

                }
                <div className='aplicar-filtro'>
                  <button onClick={() => { setActiveFilterPrice(!activeFilterPrice) }}>Aplicar</button>
                </div>
              </div>

            </section>
            <section className="container-filter-passenger">
              <h3>Pasajeros</h3>
              <div className='input-filtrado-passenger'>
                <div>
                  <label htmlFor="">Nro Pasajeros</label>
                  <input id='range-passenger' onChange={e => { setPassengerFilter(e.target.value) }} className='range-passenger' type="range" max={7} min={1} />
                </div>
                <div className='content-number-passenger'>
                  <input type="number" readOnly="readOnly" value={passengerFilter} />
                </div>
                <div className='aplicar-filtro'>
                  <button onClick={() => setActiveFilterP(!activeFilterP)}>Aplicar</button>
                </div>
              </div>
            </section>
          </div>
        </aside>

        <section className='content-all-card-t'>
          {
            loader === true ?
              <Loading size={100}></Loading>
              :
              (
                filtrado.length === 0 ?
                  <div>
                    <h2 style={{ textAlign: 'center' }}>
                      No se encontraron traslados disponibles
                    </h2>
                  </div>
                  :
                  (
                    filtrado[0] !== 0 ?

                      filtrado.map(item => {
                        return (
                          <div className='card-traslado' key={item.vehicleType}>
                            <div className="layout-card-traslado content-img">
                              <img src={item.vehicleImage} alt={item.vehicle} />
                            </div>
                            <div className='layout-card-traslado-second'>
                              <div className="content-info information-car">
                                <h3>{item.vehicle}</h3>
                                <p>{item.vehicleType} {item.meetAndGreet === true ? ' - Meet And Greet' : ''}</p>
                                <div className='content-information-p'>
                                  <div className='cuantity-p'>
                                    <div className='icons-cuantity'>
                                      <People className='icon-card-t' size="30" color="#004274" />
                                      <span>{item.passengerCapacity}</span>
                                    </div>
                                    <div className='icons-cuantity'>
                                      <Timer className='icon-card-t' size="30" color="#004274" />
                                      <span>{item.duracionInMinutes} Min</span>
                                    </div>
                                  </div>
                                  <div className='cancelacion-service'>
                                    <p style={{ color: "green" }}>Cancelacion Gratuita</p>
                                    <p>hasta el </p>
                                  </div>
                                </div>

                              </div>
                              <div className=" price-card">
                                <div className='price-content'>
                                  <span>${(item.totalPriceUSD + (item.totalPriceUSD * 0.20)).toFixed(1)}</span>
                                  <h3>${item.totalPriceUSD.toFixed(1)} USD</h3>
                                </div>
                                <div className='content-reserva'>
                                  <button>Reservar Ahora</button>
                                </div>
                                <div className='more-details'>
                                  <p>Mas detalles...</p>
                                </div>

                              </div>
                            </div>

                          </div>
                        )
                      })

                      :

                      (
                        resultados[0] === 0 ?
                          <div>
                            <h2 style={{ textAlign: 'center' }}>
                              No se encontraron traslados disponibles
                            </h2>
                          </div>

                          :
                          resultados.map(item => {
                            return (
                              <div className='card-traslado' key={item.vehicleType}>
                                <div className="layout-card-traslado content-img">
                                  <img src={item.vehicleImage} alt={item.vehicle} />
                                </div>
                                <div className='layout-card-traslado-second'>
                                  <div className="content-info information-car">
                                    <h3>{item.vehicle}</h3>
                                    <p>{item.vehicleType} {item.meetAndGreet === true ? ' - Meet And Greet' : ''}</p>
                                    <div className='content-information-p'>
                                      <div className='cuantity-p'>
                                        <div className='icons-cuantity'>
                                          <People className='icon-card-t' size="30" color="#004274" />
                                          <span>{item.passengerCapacity}</span>
                                        </div>
                                        <div className='icons-cuantity'>
                                          <Timer className='icon-card-t' size="30" color="#004274" />
                                          <span>{item.duracionInMinutes} Min</span>
                                        </div>
                                      </div>
                                      <div className='cancelacion-service'>
                                        <p style={{ color: "green" }}>Cancelacion Gratuita</p>
                                        <p>hasta el </p>
                                      </div>
                                    </div>

                                  </div>
                                  <div className=" price-card">
                                    <div className='price-content'>
                                      <span>${(item.totalPriceUSD + (item.totalPriceUSD * 0.20)).toFixed(1)}</span>
                                      <h3>${item.totalPriceUSD.toFixed(1)} USD</h3>
                                    </div>
                                    <div className='content-reserva'>
                                      <button>Reservar Ahora</button>
                                    </div>
                                    <div className='more-details'>
                                      <p>Mas detalles...</p>
                                    </div>

                                  </div>
                                </div>

                              </div>
                            )
                          })
                      )

                  )

              )

          }

        </section>
      </main>

    </div>
  )
}

export default ResultSearch